module.exports = __webpack_public_path__ + "static/media/4ODA3.34471348.jpg";